import { FontExample } from 'components/designSystem/utilityClasses/FontExample';
import { UtilityClass } from 'components/designSystem/utilityClasses/UtilityClass';
import { UtilityClassSectionHeader } from 'components/designSystem/utilityClasses/UtilityClassSectionHeader';
import { Section } from 'components/shared/Section';

const fonts = [
    <UtilityClassSectionHeader key="1" />,
    <div key="2">
        <UtilityClass
            className=".font-regular"
            example={<FontExample className="font-regular" />}
        />
        <UtilityClass
            className=".font-regular--italic"
            example={<FontExample className="font-regular--italic" />}
        />
        <UtilityClass
            className=".font-regular--uppercase"
            example={<FontExample className="font-regular--uppercase" />}
        />
        <UtilityClass
            className=".font-regular--uppercase--italic"
            example={<FontExample className="font-regular--uppercase--italic" />}
        />
        <UtilityClass
            className=".font-regular--lowercase"
            example={<FontExample className="font-regular--lowercase" />}
        />
        <UtilityClass
            className=".font-regular--lowercase--italic"
            example={<FontExample className="font-regular--lowercase--italic" />}
        />
        <UtilityClass
            className=".font-regular--capitalize"
            example={<FontExample className="font-regular--capitalize" />}
        />
        <UtilityClass
            className=".font-regular--capitalize--italic"
            example={<FontExample className="font-regular--capitalize--italic" />}
        />
        <UtilityClass
            className=".font-semi-bold--uppercase"
            example={<FontExample className="font-semi-bold--uppercase" />}
        />
        <UtilityClass
            className=".font-semi-bold--uppercase--italic"
            example={<FontExample className="font-semi-bold--uppercase--italic" />}
        />
        <UtilityClass
            className=".font-semi-bold--lowercase"
            example={<FontExample className="font-semi-bold--lowercase" />}
        />
        <UtilityClass
            className=".font-semi-bold--lowercase--italic"
            example={<FontExample className="font-semi-bold--lowercase--italic" />}
        />
        <UtilityClass
            className=".font-semi-bold--capitalize"
            example={<FontExample className="font-semi-bold--capitalize" />}
        />
        <UtilityClass
            className=".font-semi-bold--capitalize--italic"
            example={<FontExample className="font-semi-bold--capitalize--italic" />}
        />
        <UtilityClass className=".font-bold" example={<FontExample className="font-bold" />} />
        <UtilityClass
            className=".font-bold--italic"
            example={<FontExample className="font-bold--italic" />}
        />
        <UtilityClass
            className=".font-bold--uppercase"
            example={<FontExample className="font-bold--uppercase" />}
        />
        <UtilityClass
            className=".font-bold--uppercase--italic"
            example={<FontExample className="font-bold--uppercase--italic" />}
        />
        <UtilityClass
            className=".font-bold--lowercase"
            example={<FontExample className="font-bold--lowercase" />}
        />
        <UtilityClass
            className=".font-bold--lowercase--italic"
            example={<FontExample className="font-bold--lowercase--italic" />}
        />
        <UtilityClass
            className=".font-bold--capitalize"
            example={<FontExample className="font-bold--capitalize" />}
        />
        <UtilityClass
            className=".font-bold--capitalize--italic"
            example={<FontExample className="font-bold--capitalize--italic" />}
        />
    </div>,
];

export const Fonts = () => <Section title="Font Utility Classes" contentArray={fonts} />;
